module.exports = __webpack_public_path__ + "static/img/b5.1f954aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/b5.png
// module id = WhBO
// module chunks = 0